import fetch from '@/assets/js/src/util/fetch'
import { checkResponse, handleException, } from '@/assets/js/src/util/apiTools'
import { getDefaultHeaders, } from '@/assets/js/src/util/fetch/defaultHeaders'
import { useLangStore, } from '@/assets/js/src/modules/lang/_pinia/lang'
import { defineStore, getActivePinia, } from 'pinia'

const API_TOPICS = '/api/topics'

export const useTopicListStore = defineStore('topicList', {
    state () {
        return {
            topics: [],

            reload: false,
        }
    },
    actions: {
        async getTopics () {
            let activePinia = getActivePinia()
            let langStore = useLangStore(activePinia)
            try {
                // Api-Request senden
                let useCache = true
                let apiResponse = await fetch({
                    url: `${API_TOPICS}`,
                    options: {
                        headers: getDefaultHeaders({
                            useCache,
                        }),
                    },
                    useCache,
                    includeTagsInId: true,
                    tags: [
                        'topics',
                        `locale.${langStore.locale}`,
                    ],
                })

                // Api-Response prüfen
                if (checkResponse(apiResponse)) {
                    throw new Error('Fehler in Api-Response')
                }

                this.topics = apiResponse.data || []
            } catch (e) {
                // Evtl. Fehler ausgeben
                handleException(e, true, true)
            }
        },
    },
})
